import { ChatLastMessageModel } from "api";
import chatActionTypes from "constants/chat";
import { load } from "helpers/filtersStorage";
import { defaultConstants, defaultReducerBody, handleActions } from "helpers/redux";
import { Action } from "redux-actions";

const params = load("chats_params", {});

const initialState: State = {
    key: "chats",
    items: [],
    params: {
        start: 0,
        length: 30,
        filters: params.filters || [],
        queryFilter: params.queryFilter || {},
        customFilters: params.customFilters || {},
        preparedFilter: params.preparedFilter || {},
    },
    count: 0,
    isLoadingList: true,
    isLoadingCount: true,
    shouldUpdate: true,
};

type State = {
    key: "chats";
    items: ChatLastMessageModel[];
    params: {
        start: number;
        length: number;
        filters: [];
        queryFilter: {};
        customFilters: {};
        preparedFilter: {};
    };
    count: number;
    isLoadingList: boolean | {};
    isLoadingCount: boolean | {};
    shouldUpdate: boolean;
};
type ReadPayload = { chatId: number; data: {} };
type TogglePayload = { id: number; isFavorite: boolean };

type CombinedPayloads = ReadPayload | TogglePayload;

const { READ_ALL_CHATS, READ_CHAT, TOGGLE_FAVORITE_CHAT } = chatActionTypes;

export default handleActions<State, CombinedPayloads>(
    {
        ...defaultReducerBody<ChatLastMessageModel, State>(defaultConstants("CHATS"), initialState),
        [READ_ALL_CHATS]: (state: State) => ({
            ...state,
            shouldUpdate: true,
            items: state.items.map((item) => ({ ...item, unreadMessagesCount: 0 })) as ChatLastMessageModel[],
        }),
        [READ_CHAT]: (state, { payload }: Action<ReadPayload>) => ({
            ...state,
            shouldUpdate: true,
            items: state.items.map((item: ChatLastMessageModel) => ({
                ...item,
                ...(payload.chatId === item.chat?.id ? { unreadMessagesCount: 0 } : {}),
            })),
        }),
        [TOGGLE_FAVORITE_CHAT]: (state, { payload }: Action<TogglePayload>) => ({
            ...state,
            items: state.items.map((item: ChatLastMessageModel) =>
                item.id === payload.id ? { ...item, chat: { ...item.chat, isFavorite: payload.isFavorite } } : item,
            ) as ChatLastMessageModel[],
        }),
    },
    initialState,
);
